/* Pialú Drawer 2.0 — moteur (<15 Ko, zéro dépendance).
   Possède l'ATC dès le premier rendu (plus de course à l'hydratation), rend l'état
   panier embarqué côté serveur, applique les remises natives Shopify, et expose
   tout le contenu via les blocs/settings de la section (éditeur de thème). */
(function () {
  'use strict';
  var root = document.getElementById('PialuDrawer');
  if (!root || root.dataset.enabled !== 'true' || window.__pialuDrawerInit) return;
  window.__pialuDrawerInit = 1;
  window.__pialuAtcShim = 1; // met le shim anti-tap-perdu du <head> en veille

  var CFG = JSON.parse(document.getElementById('PialuDrawerCfg').textContent);
  var CART = JSON.parse(document.getElementById('PialuDrawerCart').textContent);
  var UPS = JSON.parse((document.getElementById('PialuDrawerUpsell') || { textContent: '[]' }).textContent);
  var panel = root.querySelector('.pldr-panel');
  var busyLock = false;

  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || root).querySelectorAll(s)); }
  function money(c) { return 'S/. ' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function thumb(u, w) { if (!u) return ''; var sep = u.indexOf('?') > -1 ? '&' : '?'; return u + sep + 'width=' + (w || 120); }

  /* ---------- ouverture / fermeture ---------- */
  function open() {
    if (!window.__pialuSynced) { window.__pialuSynced = 1; refreshCart().catch(function () { }); }
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    panel.setAttribute('aria-hidden', 'false');
    try { document.dispatchEvent(new CustomEvent('pialu:drawer:open')) } catch (e) { }
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    panel.setAttribute('aria-hidden', 'true');
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-pldr-close]') || e.target.classList.contains('pldr-overlay')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- API panier ---------- */
  function req(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); });
  }
  function refreshCart() { return req('/cart.js').then(function (c) { CART = c; render(); return c; }); }

  /* ---------- rendu ---------- */
  function giftState() {
    var target = CFG.giftTarget || 3;
    var n = CART.item_count;
    return { target: target, n: n, missing: Math.max(0, target - n), win: n >= target, pct: Math.min(100, Math.round(n / target * 100)) };
  }
  function shipState() {
    var t = CFG.shipThreshold; var v = CART.total_price;
    return { ok: v >= t, missing: Math.max(0, t - v), pct: Math.min(100, Math.round(v / t * 100)) };
  }
  function fmtMsg(s, vals) { return String(s || '').replace('{n}', vals.n != null ? vals.n : '').replace('{monto}', vals.monto || ''); }

  function render() {
    $('[data-pldr-count]').textContent = CART.item_count + (CART.item_count === 1 ? ' artículo' : ' artículos');

    /* bloc cadeau */
    var g = $('[data-pldr-block="gift"]');
    if (g) {
      var gs = giftState();
      var msg = gs.win ? g.dataset.msgWin : fmtMsg(g.dataset.msgProgress, { n: gs.missing });
      var save = gs.win && CART.total_discount > 0 ? ' <span class="pldr-save">' + esc(g.dataset.msgSave).replace('{monto}', money(CART.total_discount)) + '</span>' : '';
      g.classList.toggle('is-win', gs.win);
      $('p', g).innerHTML = esc(msg) + save;
      $('.pldr-fill', g).style.width = gs.pct + '%';
    }
    /* bloc envío */
    var sh = $('[data-pldr-block="ship"]');
    if (sh) {
      var ss = shipState();
      var slim = !!g; /* discret si bloc cadeau présent */
      sh.classList.toggle('pldr-ship', slim); sh.classList.toggle('pldr-goal', !slim);
      sh.classList.toggle('is-ok', slim && ss.ok); sh.classList.toggle('is-win', !slim && ss.ok);
      var dl = $('[data-pldr-deliv]');
      sh.style.display = (ss.ok && dl) ? 'none' : '';
      var m = ss.ok ? sh.dataset.msgWin : fmtMsg(sh.dataset.msgProgress, { monto: money(ss.missing) });
      $('[data-pldr-shipmsg]', sh).textContent = m;
      var f = $('.pldr-fill,.pldr-mini i', sh); if (f) f.style.width = ss.pct + '%';
    }
    /* ligne livraison (pied) : GRATIS des le seuil atteint */
    var dlv = $('[data-pldr-deliv]');
    if (dlv) {
      var free = shipState().ok;
      dlv.classList.toggle('is-free', free);
      $('[data-pldr-deliv-label]', dlv).textContent = free ? (dlv.dataset.labelFree || dlv.dataset.labelNormal) : dlv.dataset.labelNormal;
    }
    /* articles */
    var list = $('[data-pldr-items]');
    /* lignes fantomes (produit passe en brouillon/supprime apres ajout, residus d'apps) :
       jamais affichees, et purgees cote serveur une seule fois par session */
    var ghosts = (CART.items || []).filter(function (it) { return !(it.quantity > 0); });
    if (ghosts.length && !window.__pldrPurged) {
      window.__pldrPurged = 1;
      var updates = {};
      ghosts.forEach(function (g) { if (g.key) updates[g.key] = 0; });
      req('/cart/update.js', { updates: updates }).then(function (c) { CART = c; render(); }).catch(function () { });
    }
    CART = Object.assign({}, CART, { items: (CART.items || []).filter(function (it) { return it.quantity > 0; }) });
    if (!CART.items.length) {
      list.innerHTML = '<div class="pldr-empty">Tu carrito está vacío 🤍<br><a href="' + (CFG.emptyUrl || '/collections/all') + '">' + esc(CFG.emptyCta || 'Descubre nuestras joyas') + '</a></div>';
    } else {
      list.innerHTML = CART.items.map(function (it, i) {
        var free = it.final_line_price === 0 && it.original_line_price > 0;
        var disc = it.original_line_price > it.final_line_price;
        var opts = (it.variant_title && it.variant_title !== 'Default Title') ? '<small>' + esc(it.variant_title) + '</small>' : '';
        return '<div class="pldr-item" data-key="' + esc(it.key) + '">' +
          '<img loading="lazy" src="' + thumb(it.image, 116) + '" alt="">' +
          '<div class="pldr-it"><b>' + esc(it.product_title) + '</b>' + opts +
          (free ? '<span class="pldr-tagG">🎁 GRATIS</span>' : '') +
          '<div class="pldr-qty"><button data-pldr-q="-1" aria-label="menos">−</button><span>' + it.quantity + '</span><button data-pldr-q="1" aria-label="más">+</button></div></div>' +
          '<div class="pldr-pr"><b>' + money(it.final_line_price) + '</b>' + (disc ? '<span class="pldr-old">' + money(it.original_line_price) + '</span>' : '') + '</div>' +
          '<button class="pldr-del" data-pldr-q="0" aria-label="eliminar">🗑</button></div>';
      }).join('');
    }
    /* upsell : carrousel scrollable + chargement progressif */
    var up = $('[data-pldr-block="upsell"]');
    if (up) {
      var inCart = {}; CART.items.forEach(function (it) { inCart[it.product_id] = 1; });
      var picks = UPS.filter(function (p) { return !inCart[p.id]; }).slice(0, CFG.upsellMax || 24);
      var sc = $('[data-pldr-ucards]', up);
      var keep = sc.scrollLeft;
      sc.innerHTML = picks.map(function (p) {
        return '<div class="pldr-uc"><img loading="lazy" src="' + thumb(p.img, 200) + '" alt=""><b>' + esc(p.title) + '</b><small>' + money(p.price) + '</small>' +
          '<button data-pldr-add="' + p.vid + '">' + esc(up.dataset.addLabel || 'AÑADIR') + '</button></div>';
      }).join('') + '<span class="pldr-usent" data-pldr-usent></span>';
      sc.scrollLeft = keep;
      watchSentinel();
      up.style.display = (picks.length && CART.items.length) ? '' : 'none';
    }
    /* totaux + footer */
    var hasDisc = CART.total_discount > 0;
    $('[data-pldr-total]').innerHTML = (hasDisc ? '<span class="pldr-old">' + money(CART.total_price + CART.total_discount) + '</span>' : '') +
      '<b>' + money(CART.total_price) + '</b>' + (hasDisc ? ' &nbsp;<span class="pldr-save">Ahorras ' + money(CART.total_discount) + '</span>' : '');
    $('[data-pldr-cta]').textContent = (CFG.ctaLabel || 'Finalizar Compra') + ' • ' + money(CART.total_price);
    $('[data-pldr-cta]').disabled = !CART.items.length;
    var yp = $('[data-pldr-yape]'); if (yp) yp.style.display = CART.items.length ? '' : 'none';
    /* badge panier du header (le shim du head ne pilote plus l'ATC quand le drawer est present) */
    setHeaderCount(CART.item_count);
  }

  /* Pialu 2026-06-12 : le lien panier <a.header__cart-link> PORTE lui-meme l'attribut
     [data-cart-count] (cf. header.liquid) ; un textContent dessus detruisait l'icone SVG
     et le badge. On ne touche donc QUE l'attribut + le span .header__cart-link-count, en
     reproduisant exactement le markup Liquid (span direct dans le <a> pour la variante icone,
     dans .header__icon-with-label-touch-icon pour la variante libelle). Le div libelle
     [data-cart-count] contient le sous-total : on ne met a jour que son attribut. */
  function setHeaderCount(n) {
    try {
      var links = document.querySelectorAll('a[data-header-cart]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.hasAttribute('data-cart-count')) a.setAttribute('data-cart-count', n);
        var holder = a.querySelector('.header__icon-with-label-touch-icon') || a;
        var badge = holder.querySelector('.header__cart-link-count');
        if (n > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-link-count';
            holder.appendChild(badge);
          }
          badge.textContent = n;
        } else if (badge) {
          badge.parentNode.removeChild(badge);
        }
      }
      /* libelle desktop : sous-total intact, seul l'attribut suit le compte */
      var labels = document.querySelectorAll('.header__icon-with-label-touch-label[data-cart-count]');
      for (var j = 0; j < labels.length; j++) labels[j].setAttribute('data-cart-count', n);
      /* compteurs dedies eventuels (garde de compatibilite, aucun aujourd'hui) */
      var counters = document.querySelectorAll('[data-header-cart-count]');
      for (var k = 0; k < counters.length; k++) counters[k].textContent = n;
    } catch (e) { }
  }

  /* ---------- upsell : pages suivantes de la collection au scroll ---------- */
  var upsPage = 1, upsDone = false, upsLoading = false, upsIO = null;
  function watchSentinel() {
    if (!('IntersectionObserver' in window)) return;
    var sent = $('[data-pldr-usent]');
    if (!sent) return;
    if (upsIO) upsIO.disconnect();
    upsIO = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) loadMoreUpsell();
    }, { root: $('[data-pldr-ucards]'), rootMargin: '0px 220px 0px 0px' });
    upsIO.observe(sent);
  }
  function loadMoreUpsell() {
    if (upsDone || upsLoading || !CFG.upsellHandle) return;
    if (UPS.length >= (CFG.upsellMax || 24)) { upsDone = true; return; }
    upsLoading = true;
    upsPage += 1;
    fetch('/collections/' + CFG.upsellHandle + '/products.json?limit=24&page=' + upsPage)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d && d.products) || [];
        if (!prods.length) { upsDone = true; return; }
        var seen = {}; UPS.forEach(function (u) { seen[u.id] = 1; });
        prods.forEach(function (pr) {
          if (seen[pr.id]) return;
          var v = (pr.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          var cents = Math.round(parseFloat(v.price) * 100);
          if (!(cents > 1900)) return;
          var img = pr.images && pr.images[0] && pr.images[0].src;
          if (!img) return;
          UPS.push({ id: pr.id, vid: v.id, title: pr.title, price: cents, img: img });
        });
        render();
      })
      .catch(function () { })
      .then(function () { upsLoading = false; });
  }

  /* ---------- mutations ---------- */
  function busy(b) { busyLock = b; }
  function addById(id, qty) {
    if (busyLock) return Promise.resolve();
    busy(true);
    if (!root.classList.contains('is-open')) maybeOpen();
    return req('/cart/add.js', { id: Number(id), quantity: qty || 1 })
      .then(refreshCart).then(function () { busy(false); })
      .catch(function (e) { busy(false); toast((e && e.description) || 'No se pudo agregar. Inténtalo de nuevo.'); });
  }
  function addByForm(form) {
    if (busyLock) return;
    busy(true);
    maybeOpen(); /* ouverture optimiste : feedback immediat, la reponse reseau met a jour */
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
      .then(refreshCart).then(function () { busy(false); try { document.dispatchEvent(new CustomEvent('pialu:drawer:add')) } catch (e) { } })
      .catch(function (e) { busy(false); refreshCart().catch(function () { }); toast((e && e.description) || 'No se pudo agregar. Revisa la talla seleccionada.'); });
  }
  function changeLine(key, q) {
    if (busyLock) return;
    busy(true);
    req('/cart/change.js', { id: key, quantity: q }).then(function (c) { CART = c; render(); busy(false); })
      .catch(function (e) { busy(false); refreshCart().catch(function () { }); toast((e && e.description) || 'No se pudo actualizar. Inténtalo de nuevo.'); });
  }
  function maybeOpen() { if (CFG.autoOpen) open(); else toast('✓ Agregado al carrito', true); }
  function toast(msg, viewCart) {
    var old = document.getElementById('pldrToast'); if (old) old.remove();
    var d = document.createElement('div');
    d.id = 'pldrToast'; d.className = 'pldr-toast';
    d.innerHTML = '<span>' + esc(msg) + '</span>' + (viewCart ? '<a href="/cart" data-pldr-viewcart>Ver carrito (' + CART.item_count + ')</a>' : '');
    d.addEventListener('click', function (ev) { if (ev.target.hasAttribute('data-pldr-viewcart')) { ev.preventDefault(); d.remove(); open(); } });
    document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 5000);
  }

  /* ---------- interceptions globales (capture, actives dès le parse) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    /* AÑADIR upsell */
    var ub = t.closest && t.closest('[data-pldr-add]');
    if (ub) { e.preventDefault(); if (!busyLock) { ub.disabled = true; ub.textContent = 'Agregando…'; } addById(ub.getAttribute('data-pldr-add')); return; }
    /* qty / suppr dans le drawer */
    var qb = t.closest && t.closest('[data-pldr-q]');
    if (qb && root.contains(qb)) {
      e.preventDefault();
      var item = qb.closest('[data-key]'); var key = item.getAttribute('data-key');
      var entry = CART.items.filter(function (it) { return it.key === key; })[0];
      var cur = entry ? entry.quantity : 1;
      var d = Number(qb.getAttribute('data-pldr-q'));
      changeLine(key, d === 0 ? 0 : Math.max(0, cur + d)); return;
    }
    /* checkout */
    if (t.closest && t.closest('[data-pldr-cta]')) { e.preventDefault(); window.location.href = '/checkout'; return; }
    if (t.closest && t.closest('[data-pldr-yape]')) {
      e.preventDefault();
      var yb = document.querySelector('[data-yape-button] button, .yape-button, #yape-cart-btn');
      if (yb) { close(); yb.click(); } else { window.location.href = '/cart#yape'; }
      return;
    }
    /* bouton ATC produit / quick-add */
    var atc = t.closest && t.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], button[name="add"]');
    if (atc) {
      var form = atc.closest('form[action*="/cart/add"]');
      if (form) { e.preventDefault(); e.stopImmediatePropagation(); addByForm(form); return; }
    }
    /* icône / liens panier → drawer */
    var cl = t.closest && t.closest('a[href$="/cart"], a[href="/cart"], a.header__cart-link');
    if (cl) { e.preventDefault(); e.stopImmediatePropagation(); open(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') > -1) {
      e.preventDefault(); e.stopImmediatePropagation(); addByForm(f);
    }
  }, true);

  /* ---------- éditeur de thème : preview vivante ---------- */
  document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.contains(root)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.contains(root)) close(); });

  /* Filet universel : tout POST /cart/add reussi initie HORS moteur (quick-add
     collections, modal variantes du theme, apps) declenche refresh + ouverture. */
  (function () {
    var _fetch = window.fetch;
    window.fetch = function (u, o) {
      var pr = _fetch.apply(this, arguments);
      try {
        var url = String((u && u.url) || u || '');
        var method = ((o && o.method) || (u && u.method) || 'GET').toUpperCase();
        if (method === 'POST' && /\/cart\/add(\.js)?([?#]|$)/.test(url) && !busyLock) {
          pr.then(function (r) {
            if (r && r.ok) refreshCart().then(function () { maybeOpen(); }).catch(function () { });
          }).catch(function () { });
        }
      } catch (_) { }
      return pr;
    };
  })();

  render();
  window.__pialuDrawerOpen = open;
  if (window.__pialuOpenPending) { window.__pialuOpenPending = 0; open(); }
  try { document.dispatchEvent(new CustomEvent('pialu:drawer:ready')) } catch (e) { }
})();
